import React, {useState} from 'react';
import {Button, message} from "antd";
import {loadStripe} from "@stripe/stripe-js";
import {useAuth0} from "../../services/auth0";
import {withRouter} from 'react-router-dom';
import {createPaymentSubsciption} from "../../services/api.service";

const {REACT_APP_STRIP_PUBLIC_KEY} = process.env;

const Plan = ({subs, history}) => {
    const {user} = useAuth0();
    const [btnLoaders, setLoader] = useState(false);

    const createSubscriptionSession = async (planId) => {
        try {
            setLoader(true);
            const obj = {
                planId,
                email: user.email,
                userId: user.sub,
                origin: window.origin
            };
            //.split('|')[1]
            const {data: {data}} = await createPaymentSubsciption({...obj});
            
            if (!!data.planUpdated)
                history.push('/payment-success');
            else
                await checkout(data.id);
            setLoader(false);
        } catch (err) {
            
            console.log(err)
            message.error('Something went error');
            setLoader(false);
        }
    };

    const checkout = async (sessionId) => {
        try {
            const stripe = await loadStripe(REACT_APP_STRIP_PUBLIC_KEY);
            const {error} = await stripe.redirectToCheckout({
                sessionId: sessionId
            });
            console.log(error)
        } catch (err) {
            console.log(err)
        }
    };

    return (
        <div className="card mb-5 mb-lg-0">
            <div className="card-body">
                <h5 className="card-title text-muted text-uppercase text-center">{subs.nickname}</h5>
                <h6 className="card-price text-center">${((subs.amount / 100)/parseInt(subs.metadata.totalMinutes)).toFixed(2)}<span
                    className="period">per minute</span></h6>
                <hr/>
                <ul className="fa-ul">
                    <li>
                        <span className="fa-li">
                            <i className="fas fa-check" />
                        </span>Subscription : ${subs.amount / 100 } per Month
                    </li>
                    <li>
                        <span className="fa-li">
                            <i className="fas fa-check" />
                        </span>Total Minutes per Month : {subs.metadata.totalMinutes}
                    </li>
                    <li>
                        <span className="fa-li">
                            <i className="fas fa-check"/>
                        </span>Maximum Files per Month : {subs.metadata.filesLimit}
                    </li>
                    <li>
                        <span className="fa-li">
                            <i className="fas fa-check"/>
                        </span>Maximum Media Length: {subs.metadata.mediaLimit} minutes
                    </li>
                    <li>
                        <span className="fa-li">
                            <i className="fas fa-check" />
                        </span>Maximum words per Month : {subs.metadata.wordsLimit}
                    </li>
                </ul>
                <Button type="primary" block value="large"
                        shape="round"
                        loading={btnLoaders}
                        className="text-uppercase"
                        onClick={() => createSubscriptionSession(subs.id)}>Buy</Button>
            </div>
        </div>
    )
};

export default withRouter(Plan);
